export class FilterService {
  pPromise: Promise<void> = Promise.resolve();
  isPromiseSet: boolean = false;
  disarmCb: () => void = null;

  get promise() {
    if(this.pPromise) {
      return this.pPromise; 
    } else {
      //console.error('FilterService: promise is not set');
      return Promise.resolve();
    }
  }

  get isSet() {
    return this.isPromiseSet;
  }

  install(Vue: any, options: any) { 
    Vue.prototype.$filter = this;
  }

  clear() {
    this.isPromiseSet = false;
  }

  set() {
    this.isPromiseSet = true;
    this.pPromise = new Promise((resolve) => {
      this.disarmCb = () => {
        resolve();
      }
    });
  }

  disarm() {
    if(this.disarmCb) {
      this.disarmCb();
    }
  }
}

export default new FilterService();
